import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    setMsg("");
    try {
      const r = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data?.error || `HTTP ${r.status}`);
      // store access token in memory (window.appAuth) and sessionStorage as fallback
      window.appAuth = { token: data.accessToken, user: data.user };
      sessionStorage.setItem("accessToken", data.accessToken);
      const to = (loc.state && loc.state.from) || "/quotes";
      nav(to, { replace: true });
    } catch (e2) {
      setMsg(String(e2.message || e2));
    }
  }

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: 420, margin: "40px auto" }}>
        <h2 className="section-title" style={{ margin: 0 }}>Sign in</h2>
        <div style={{ borderTop: "1px solid var(--border)", margin: "8px 0 12px" }} />
        <form onSubmit={submit} className="form-grid" style={{ gridTemplateColumns: "1fr", gap: 12 }}>
          <div>
            <div className="label">Email</div>
            <input className="input" value={email} onChange={e => setEmail(e.target.value)} autoFocus />
          </div>
          <div>
            <div className="label">Password</div>
            <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          {msg && (
            <div style={{ color: "#b91c1c", background: "#fee2e2", border: "1px solid #fecaca", padding: "8px 10px", borderRadius: 8 }}>
              {msg}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <button className="btn" type="submit">Sign in</button>
          </div>
        </form>
      </div>
    </div>
  );
}

